import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Laverage(props) {
  return (
    <div className="laverage_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Our Adaptive, Clear-Cut App Development Process</h2>
            <p>
              Our mobile app development team in Austin offers customized
              solutions that align with your specific business requirements. We
              recognize that each business may have distinct organizational
              structures, and we adapt our approach to integrate with these
              operational processes flawlessly, guaranteeing the creation of a
              perfectly operated app.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>Sketch</h6>
                <p>Kick-off with app idea & development scope</p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Design</h6>
                <p>
                  Create intuitive, attractive interfaces adequate for business
                  features
                </p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Develop</h6>
                <p>
                  Code performant frontend functionalities with supportive,
                  extensible backend
                </p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Test</h6>
                <p>
                  Fine-tune with component-based & collective testing with
                  real-like staging
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Rollout & Upscale</h6>
                <p>
                  Release the best version for users. Maintain & update as per
                  insights & demand
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
